import type { ThemeConfig } from "antd";

// Global background color of the whole tool (change this one value if needed)
export const APP_BG = "#F5F6F8";

export const antdTheme: ThemeConfig = {
  token: {
    // Applies to all antd Layout backgrounds app-wide
    colorBgLayout: APP_BG,
  },
  components: {
    Table: {
      headerBg: "#E8F1FB",
      headerColor: "#1F2937",
      headerSortActiveBg: "#E8F1FB",
      // Thicker & darker cell / column dividers
      borderColor: "#D0D0D0",
      headerSplitColor: "#D0D0D0",
    },
  },
};
